import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldBlockCss = "f17t27ku";
export const FieldBlock = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(fieldBlockCss, props.className)} />);
const labelCss = "l1dq9qhq";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");